import React, { useState } from 'react';

import ShareBar from '../share-bar';
import styles from './mobile-menu.module.scss';

const MobileShareModal = ({ active, hideModal, shareOptions }) => {
    return (
        <div
            className={styles.mobileShareModal}
            style={{ opacity: active ? 1 : 0, zIndex: active ? 3 : -1 }}
            aria-hidden={!active}
            role="modal"
        >
            <img
                alt="close-icon-button"
                className={styles.mobileShareModalClose}
                src={require('../../images/icons/close.svg')}
                onClick={hideModal}
            />
            <h2 aria-hidden={active} className={styles.mobileShareModalTitle}>
                Share this story
            </h2>
            <ShareBar {...shareOptions} />
        </div>
    );
};

const MobileMenu = ({ currentSlide = 2, totalSlides = 10, nextSlide, prevSlide, navigateToHome, shareOptions }) => {
    const [modalActive, setModalActive] = useState(false);

    const toggleModal = () => setModalActive(!modalActive);
    const hideModal = () => setModalActive(false);

    return (
        <>
            <div className={styles.mobileMenu} role="navigation">
                <img
                    aria-label="Show share panel"
                    role="button"
                    alt="toggle-icon-button"
                    className={styles.mobileMenuIcon}
                    src={require('../../images/icons/share.svg')}
                    onClick={toggleModal}
                />
                <div aria-label="Slide Controls" className={styles.mobileMenuControls}>
                    <div aria-label="Next Slide" className={styles.mobileMenuControlsButton} onClick={prevSlide}>
                        <img
                            aria-hidden
                            alt="down-icon-button"
                            className={styles.mobileMenuIcon}
                            src={require('../../images/icons/arrow.svg')}
                        />
                    </div>
                    <div aria-label={`Slide ${currentSlide + 1} of ${totalSlides}`}>
                        <span aria-hidden className={styles.mobileMenuControlsLabel}>
                            <strong>{currentSlide + 1}</strong>
                            <div className={styles.mobileMenuControlsLabelSeperator} />
                            {totalSlides}
                        </span>
                    </div>
                    <div aria-label="Previous Slide" className={styles.mobileMenuControlsButton} onClick={nextSlide}>
                        <img
                            aria-hidden
                            alt="up-icon-button"
                            className={styles.mobileMenuIcon}
                            src={require('../../images/icons/arrow.svg')}
                        />
                    </div>
                </div>
                <img
                    aria-label="Navigate to cover"
                    role="button"
                    alt="home-icon-button"
                    className={styles.mobileMenuIcon}
                    src={require('../../images/icons/home.svg')}
                    onClick={navigateToHome}
                />
            </div>
            <MobileShareModal active={modalActive} hideModal={hideModal} shareOptions={shareOptions} />
        </>
    );
};

export default MobileMenu;
